import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { OkDialogModel } from './ok-dialog-model';

@Component({
    selector: 'app-ok-dialog',
    templateUrl: './ok-dialog.component.html',
    styleUrls: ['./ok-dialog.component.scss'],
    standalone: false
})
export class OkDialogComponent implements OnInit {

    constructor(
        public dialogRef: MatDialogRef<OkDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: OkDialogModel,
    ) { }

    ngOnInit(): void {
    }


    onClose(): void {
        this.dialogRef.close();
    }

}
